<template>
  <div class="slide">
    <!--<el-carousel class="el-carousel-wrapper">-->
    <!--<el-carousel-item v-for="item in slidePiclist" :key="item.id">-->
    <!--<img :src="imgUrl+item.imgUrl" @click="goDeail(item)"  alt="易极云课堂">-->
    <!--</el-carousel-item>-->
    <!--</el-carousel>   @transitionend="transitionend"-->
    <wc-swiper
      v-if="slidePiclist.length"
      class="swiper"
      :autoplay="true"
      :defaultSlide="0"
      :interval="10000"
      :pagination="true"
    >
      <wc-slide v-for="item in slidePiclist" :key="item.id">
        <img
          :src="item.imgUrl | filterImageBaseURL(imgUrl)"
          @click="goDeail(item)"
          alt="易极云课堂"
        />
      </wc-slide>
    </wc-swiper>
  </div>
</template>

<script>
import { getbanner } from "@/api/banner.js";
import global from "@/common/js/global";
import { getcourseIntro } from "@/api/course";
export default {
  data() {
    return {
      slidePiclist: [],
      imgUrl: global.imgUrl,
      courseorgInfoId: ""
    };
  },
  created() {
    getbanner().then(res => {
      this.slidePiclist = res.data.rows;
    });
  },
  methods: {
    goDeail(item) {
      // 为linkType为1 是内连接  则跳转到详情，actionType为1是课程，2-跳转内链接（招生详情），3-跳转内链接（活动详情），4-跳转内链接（预告详情）
      if (item.linkType == 1 && item.actionType == 1) {
        // 查课程详情信息
        let obj = {
          courseId: item.innerLink
        };
        getcourseIntro(obj).then(res => {
          if (item.hasOwnProperty("linkType") && item.linkType === 1) {
            window.open(item.linkUrl, "_blank");
            return;
          }
          this.courseorgInfoId = res.data.orgInfoId;
          let routeData = this.$router.resolve({
            path: "/CourseDetails",
            query: { id: item.innerLink, orgInfoId: this.courseorgInfoId }
          });
          window.open(routeData.href, "_self");
        });
      } else if (item.linkType == 1 && item.actionType == 2) {
        window.location.href =
          this.imgUrl +
          "/html5/yjykt_shares/h5template/zsindex.html" +
          "?activityId=" +
          item.innerLink;
      } else if (item.linkType == 0) {
        window.location.href = item.outerLink;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
.swiper {
  img {
    width: 100%;
    /*height: auto;*/
    height: 200px;
  }
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 16px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item {
  background-color: #333;
  img {
    cursor: pointer;
    width: 100%;
    /*height: auto;*/
    height: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/wapslider.vue